import { request } from "./config";
import { configs } from "@/configs";

const url = (path) => `${configs.serveBaseURL}${path}`;

export const battleRoyaleRooms = () => request.get(url("/BattleRoyale/Rooms"));
export const battleRoyaleRoom = (id) => request.get(url(`/BattleRoyale/Room/${id}`));
export const createBattleRoyaleRoom = () => request.post(url("/BattleRoyale/Room"), {});
export const joinBattleRoyaleSeat = (id, data) => request.post(url(`/BattleRoyale/Room/${id}/JoinSeat`), data);
export const fillBattleRoyaleAi = (id, data) => request.post(url(`/BattleRoyale/Room/${id}/Ai`), data);
export const fillBattleRoyaleAiSeat = (id, seatNo) => request.post(url(`/BattleRoyale/Room/${id}/Seat/${seatNo}/Ai`));
export const startBattleRoyaleRoom = (id) => request.post(url(`/BattleRoyale/Room/${id}/Start`));
export const chooseBattleRoyaleNumber = (id, data) => request.post(url(`/BattleRoyale/Room/${id}/Choice`), data);
